import { render, staticRenderFns } from "./reportImport.vue?vue&type=template&id=513b0b16&scoped=true"
import script from "./reportImport.vue?vue&type=script&lang=js"
export * from "./reportImport.vue?vue&type=script&lang=js"
import style0 from "./reportImport.vue?vue&type=style&index=0&id=513b0b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b0b16",
  null
  
)

export default component.exports